import * as Tone from "tone"
import { random_num, shuffleArray } from "../../common/utils";
import { featuresContext as features } from "../features";

const {speed, ripples, baseHue } = features;

const baseFreq = Tone.Frequency(baseHue).toNote().charAt(0);

// bass
const reverb = new Tone.Reverb({
  decay: 1,
  wet: 0.2,
  // preDelay: 0.2,
});
const effect = new Tone.FeedbackDelay(speed / ripples / 2, 0.35);
effect.wet.value = 0.8;
const filter = new Tone.Filter(500, "lowpass", "-12");
const lfo = new Tone.LFO(`${ripples}n`, 100, 500);
lfo.connect(filter.frequency);
const bass = new Tone.Synth({
  oscillator: {
    type: "sine",
    count: 8,
    spread: 50,
  },
  envelope: {
    attack: 0.9,
    decay: 0.9,
    sustain: 0.2,
    release: 0.9,
  },
  fadeIn: 2,
  fadeOut: 2,
  volume: -Infinity,
});
bass.set({ detune: -129 });
const bassNote = `${baseFreq}2`;
const shuffledbassNotes = shuffleArray(
  [
    bassNote,
    [
      Tone.Frequency(bassNote).transpose(-7),
      Tone.Frequency(bassNote).transpose(-5),
    ],
    Tone.Frequency(bassNote).transpose(-12),
    Tone.Frequency(bassNote).transpose(-7),
  ],
  random_num(0, 1)
);
bass.chain(reverb, filter, Tone.Destination);
const bassSequence = new Tone.Sequence(
  (time, note) => {
    bass.triggerAttackRelease(note, "1m");
  },
  shuffledbassNotes,
  "1m"
)

export const startBass = () => {
  lfo.start();
  bassSequence.start()
  bass.volume.rampTo(-5, 1)
}

export const stopBass = () => {
  lfo.stop();
  bassSequence.stop()
  bass.volume.rampTo(-Infinity, 1)
}